import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Overlay from "../containers/general/overlay"
import { Link, Redirect } from "react-router-dom"
import LoadingOverlay from "containers/general/loadingOverlay"
import { compose } from "redux"
import { getWeeklyPayload, loadingStatus } from "../actions"
import classNames from "classnames"
import _ from "lodash"
import settings from "settings"
import moment from "moment"
import times from "helpers/times"
import timesFromPoint from "helpers/timesFromPoint"
import WeeklyMethods from "combined/weekly"
import WeeklyRender from "components/WeeklyRender"
import MobileMenuButton from "components/MobileMenuButton"
import yearlyTimes from "helpers/yearlyTimes"

import "chartjs-plugin-datalabels"
Chart.defaults.global.plugins.datalabels.color = "black"
Chart.defaults.global.plugins.datalabels.display = function (ctx) {
	//
	return ctx.dataset.data[ctx.dataIndex] !== 0
}

import "chartjs-plugin-zoom"

// Island Weekly Report
class WeeklyReport extends Component {
	constructor(props) {
		super(props)
		this.methods = new WeeklyMethods()
		this.state = {
			name: "",
			active: settings.weekly && settings.weekly.summary ? "summary" : "week",
			island: true,
			nav: [
				...(settings.weekly && settings.weekly.summary
					? [{ id: "summary", name: "Summary", icon: "fas fa-book-open" }]
					: []),
				{ id: "week", name: "This Week", icon: "fad fa-calendar-week" },
				{ id: "year", name: "Year to Date", icon: "fad fa-calendar-alt" },
				...(settings?.weekly?.ptd
					? [{ id: "ptd", name: "Project To Date", icon: "fa-solid fa-backward-step" }]
					: []),
			],
			endWeek: moment().startOf("isoweek").unix(), //? this used to be week on 7/19/22
			startWeek: moment.unix(moment().startOf("isoWeek").unix()).subtract(7, "days").unix(),
			startYear: moment().startOf("year").unix(),
			priorStartWeek: times().priorStartWeek,
			priorEndWeek: times().priorEndWeek,
			reportYear: 0,
			sales: [],
			salesInput: [],
			starts: [],
			lastYearSales: [],
			lastYearCancels: [],
			selectedWeek: 0,
			closings: [],
			bustouts: [],
			allSales: [],
			allBusts: [],
			trafficArray: {
				individual: [],
				grouped: [],
			},
			monthly: {},
			weeklyTotals: {
				gross: 0,
				busts: 0,
				closings: 0,
				net: 0,
				traffic: 0,
				starts: 0,
				copilot: 0,
				builderTraffic: 0,
				welcomeTraffic: 0,
			},
			summary: {
				weekly: {
					sales: [],
					starts: [],
					lastYearSales: [],
					lastYearCancels: [],
					selectedWeek: 0,
					closings: [],
					bustouts: [],
					allSales: [],
					allBusts: [],
					weeklyTotals: {
						gross: 0,
						busts: 0,
						closings: 0,
						net: 0,
						traffic: 0,
						starts: 0,
						builderTraffic: 0,
						welcomeTraffic: 0,
					},
				},
				ytd: {
					sales: [],
					starts: [],
					lastYearSales: [],
					lastYearCancels: [],
					selectedWeek: 0,
					closings: [],
					bustouts: [],
					allSales: [],
					allBusts: [],
					weeklyTotals: {
						gross: 0,
						busts: 0,
						closings: 0,
						net: 0,
						traffic: 0,
						starts: 0,
						copilot: 0,
						builderTraffic: 0,
						welcomeTraffic: 0,
					},
				},
			},
			times: timesFromPoint(0),
			time: times(),
			sorted: {
				sales: [],
				cancels: [],
				closings: [],
				starts: [],
			},
			cumulativeShowLabels: {
				display: true,
				flip: () => {
					let c = _.cloneDeep(this.state.cumulativeShowLabels)
					this.setState({
						cumulativeShowLabels: { display: !c.display, flip: c.flip },
					})
				},
			},
		}
	}

	componentDidMount() {
		let key = this.props.match.params.key
		this.props.getWeeklyPayload(key)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.payloadStatus !== this.props.payloadStatus) {
			let timeVar = timesFromPoint(this.props.payload.time)
			let year = parseInt(moment.unix(this.props.payload.time).format("YYYY"))
			timeVar.reportYear = year
			if (timeVar.curWeek == 53) {
				// We split week 53 and week 0 into two weeks for eoy reporting.  week 0 is internationally known as the week that contains jan 1, but we split it.

				// End of year
				if (year !== timeVar.year) {
					if (_.has(yearlyTimes, `${timeVar.year - 1}.lastWeek.start`)) {
						console.log("%c" + `Loading End of Year...`, "background: #222; color: #bada55")
						timeVar.selectedYear = timeVar.year - 1
						timeVar.startWeek = yearlyTimes[timeVar.selectedYear].lastWeek.start
						timeVar.endWeek = yearlyTimes[timeVar.selectedYear].lastWeek.end
						timeVar.startDayName = moment.unix(timeVar.startWeek).format("dddd")
						timeVar.endDayName = moment.unix(timeVar.endWeek).format("dddd")
						timeVar.year = timeVar.year - 1
						timeVar.special = true
					}
				}
				// Beginning of year
				else {
					if (_.has(yearlyTimes, `${timeVar.year}.firstWeek.start`)) {
						console.log("%c" + `Loading Beginning of Year...`, "background: #222; color: #bada55")
						timeVar.selectedYear = timeVar.year
						timeVar.startWeek = yearlyTimes[timeVar.selectedYear].firstWeek.start
						timeVar.endWeek = yearlyTimes[timeVar.selectedYear].firstWeek.end
						timeVar.startDayName = moment.unix(timeVar.startWeek).format("dddd")
						timeVar.endDayName = moment.unix(timeVar.endWeek).format("dddd")
						timeVar.year = timeVar.year
						timeVar.curWeek = 0
						timeVar.special = true
					}
				}
			}
			// Week 0 logic
			else if (
				[52, 53].includes(timeVar.curWeek) &&
				moment.unix(this.props.payload.time).format("MMM") == "Jan"
			) {
				console.log("%c" + `In week 0`, "background: #222; color: #bada55")
				timeVar.startWeek = moment().year(year).startOf("year").startOf("day").unix()
				timeVar.endDayName = moment.unix(timeVar.endWeek).format("dddd")
				timeVar.curWeek = 0
				timeVar.special = true
			}
			// now week 52 for years that only have 52
			else if (timeVar.curWeek == 52 && moment().year(year).isoWeeksInYear() == 52) {
				console.log("%c" + `In week 52 for year with 52 total weeks.`, "background: #222; color: #bada55")
				//timeVar.endWeek = moment().year(year).endOf("year").endOf("day").unix()
				//timeVar.endDayName = moment.unix(timeVar.endWeek).format("dddd")
				//timeVar.special = true
			}
			this.setState({ times: timeVar, selectedWeek: timeVar.curWeek, reportYear: timeVar.year }, () => {
				this.changeReport(
					settings.weekly && settings.weekly.summary
						? { id: "summary", name: "Summary" }
						: { id: "week", name: "This Week" }
				)
				//console.log(this.state)
			})
		}
	}

	changeReport = (r) => {
		let prop = _.find(this.props.payload.public.properties, { id: this.props.payload.weekly.id })
		let d
		let sale_date = "sale_date"
		let closing_date = "closing_date"
		let bustout_date = "bustout_date"
		if (settings?.weekly?.useInputDate) {
			sale_date = "addedDate"
			closing_date = "closing_report_time"
			bustout_date = "bustout_report_time"
		}
		const buildYearly = () => {
			let welcomeTraffic = 0
			let builderTraffic = 0
			let copilot = 0
			let numberVisits = {
				1: 0,
				2: 0,
				3: 0,
				4: 0,
				"5+": 0,
			}
			let trafficEmailStore = {}
			_.forEach(this.props.payload.traffic.current.entries, (v) => {
				if (v.welcomeCenter) welcomeTraffic++
				else builderTraffic++
				if (!_.has(trafficEmailStore, v.email)) {
					trafficEmailStore[v.email] = 0
				}
				if (v.copilot) copilot++
				trafficEmailStore[v.email]++
			})
			_.forEach(this.props.payload.traffic.current.grouped.array, (v) => {
				if (v.welcomeCenter) welcomeTraffic += v.prospect_count + v.realtor_count
				else builderTraffic += v.prospect_count + v.realtor_count
			})

			// Now add the number of visits
			_.forEach(trafficEmailStore, (v) => {
				if (v >= 5) {
					numberVisits["5+"]++
				} else {
					numberVisits[v]++
				}
			})
			let allSales = _.filter(this.props.payload.sales.allSales, (v) => {
				return v[sale_date] >= this.state.times.endWeekStartYear && v[sale_date] < this.state.times.endWeek
			})
			let salesInput = _.filter(this.props.payload.sales.allSales, (v) => {
				return v.addedDate >= this.state.times.endWeekStartYear && v.addedDate < this.state.times.endWeek
			})
			let allBusts = _.filter(this.props.payload.bustouts.allBusts, (v) => {
				return (
					v[bustout_date] >= this.state.times.endWeekStartYear && v[bustout_date] < this.state.times.endWeek
				)
			})
			let allClosings = _.filter(this.props.payload.closings.allClosings, (v) => {
				return (
					v[closing_date] >= this.state.times.endWeekStartYear && v[closing_date] < this.state.times.endWeek
				)
			})
			let allStarts = _.filter(this.props.payload.starts.allStarts, (v) => {
				return v.start_date >= this.state.times.endWeekStartYear && v.start_date < this.state.times.endWeek
			})
			let f = {
				active: r.id,
				sales: allSales,
				starts: allStarts,
				salesInput,
				bustouts: allBusts,
				closings: allClosings,
				projections: this.props.payload.projections,
				lastYearSales: this.props.payload.sales.lastSales,
				lastYearCancels: this.props.payload.bustouts.lastYearCancels,
				name: r.name,
				weeklyTotals: {
					gross: allSales.length,
					busts: allBusts.length,
					closings: allClosings.length,
					net: allSales.length - allBusts.length,
					traffic: this.props.payload.traffic.current.total + this.props.payload.traffic.current.groupedTotal,
					starts: allStarts.length,
					welcomeTraffic,
					builderTraffic,
					copilot,
					numberVisits,
				},
			}
			return f
		}
		const buildWeekly = () => {
			let traffic = 0
			let builderTraffic = 0
			let welcomeTraffic = 0
			let copilot = 0
			let lastYearSales = []
			let lastYearCancels = []
			let projections = []
			let webAnalytics = _.get(this.props.payload, `exec.weeklyReport.webAnalytics`)
			let store
			let specs = []
			let numberVisits = {
				1: 0,
				2: 0,
				3: 0,
				4: 0,
				"5+": 0,
			}
			let trafficEmailStore = {}
			let trafficArray = {
				individual: this.props.payload.traffic.current.entries,
				grouped: this.props.payload.traffic.current.grouped.array,
			}
			let sales = _.filter(this.props.payload.sales.allSales, (v) => {
				return v[sale_date] >= this.state.times.startWeek && v[sale_date] < this.state.times.endWeek
			})
			let salesInput = _.filter(this.props.payload.sales.allSales, (v) => {
				return v.addedDate >= this.state.times.startWeek && v.addedDate < this.state.times.endWeek
			})
			let cancels = _.filter(this.props.payload.bustouts.allBusts, (v) => {
				return v[bustout_date] >= this.state.times.startWeek && v[bustout_date] < this.state.times.endWeek
			})
			let closings = _.filter(this.props.payload.closings.allClosings, (v) => {
				return v[closing_date] >= this.state.times.startWeek && v[closing_date] < this.state.times.endWeek
			})
			_.forEach(this.props.payload.traffic.current.entries, (v) => {
				if (v.traffic_date >= this.state.times.startWeek && v.traffic_date < this.state.times.endWeek) {
					traffic++
					if (v.welcomeCenter) welcomeTraffic++
					else builderTraffic++
					if (v.copilot) copilot++
					if (!_.has(trafficEmailStore, v.email)) {
						trafficEmailStore[v.email] = 0
					}
					trafficEmailStore[v.email]++
				}
			})
			_.forEach(this.props.payload.traffic.current.grouped.array, (v) => {
				if (v.traffic_date >= this.state.times.startWeek && v.traffic_date < this.state.times.endWeek) {
					traffic += v.prospect_count + v.realtor_count
					if (v.welcomeCenter) welcomeTraffic += v.prospect_count + v.realtor_count
					else builderTraffic += v.prospect_count + v.realtor_count
				}
			})
			_.forEach(this.props.payload.sales.lastSales, (v) => {
				if (
					v[sale_date] >= this.state.times.dayLastYear &&
					v[sale_date] < this.state.times.dayLastYearPlusWeek
				) {
					lastYearSales.push(v)
				}
			})
			_.forEach(this.props.payload.bustouts.lastYearCancels, (v) => {
				if (
					v[bustout_date] >= this.state.times.dayLastYear &&
					v[bustout_date] < this.state.times.dayLastYearPlusWeek
				) {
					lastYearCancels.push(v)
				}
			})
			_.forEach(this.props.payload.projections, (v) => {
				if (v.month == this.state.time.curMonth) {
					projections.push(v)
				}
			})
			// Now add the number of visits
			_.forEach(trafficEmailStore, (v) => {
				if (v >= 5) {
					numberVisits["5+"]++
				} else {
					numberVisits[v]++
				}
			})
			// Spec inventory
			store = {}
			_.forEach(this.props.payload.weekly.specs, (v) => {
				try {
					v.builder_name = v.builder_name.replace(/[^\w- ]+/g, "")
					v.section_name = v.section_name.replace(/[^\w- ]+/g, "")
					if (v[closing_date] || !v.start_date || v.model || !v.takedown_date) return
					if (!v.section_name || !v.builder_name || !v.lot_type_name)
						throw `Cannot find required variable for LotID: ${v.id}`
					let path = `${v.builder_name}.${v.lot_type_name}.${v.section_name}`
					if (!_.has(store, path)) {
						_.setWith(
							store,
							path,
							{
								under_construction: 0,
								spec: 0,
								under_construction_no_contract: 0,
								under_construction_contract: 0,
								specs_no_contract: 0,
								move_in_ready_specs: 0,
							},
							Object
						)
					}
					if (v.start_date && v.complete_date) store[v.builder_name][v.lot_type_name][v.section_name].spec++
					else if (v.start_date && !v.complete_date)
						store[v.builder_name][v.lot_type_name][v.section_name].under_construction++
					if (v.lot_status !== "Contract" && !v.complete_date)
						store[v.builder_name][v.lot_type_name][v.section_name].under_construction_no_contract++
					else if (v.sale_id && !v.complete_date) {
						store[v.builder_name][v.lot_type_name][v.section_name].under_construction_contract++
					}
					if (v.lot_status !== "Contract" && v.complete_date)
						store[v.builder_name][v.lot_type_name][v.section_name].specs_no_contract++
					if (v.complete_date && !v.sale_id && !v.model) {
						store[v.builder_name][v.lot_type_name][v.section_name].move_in_ready_specs++
					}
				} catch (e) {
					console.warn(e)
				}
			})
			_.forEach(store, (v1, builder) => {
				_.forEach(v1, (v2, lot_type) => {
					_.forEach(v2, (v, section) => {
						specs.push({
							builder,
							lot_type,
							section,
							under_construction: v.under_construction,
							spec: v.spec,
							under_construction_no_contract: v.under_construction_no_contract,
							specs_no_contract: v.specs_no_contract,
							move_in_ready_specs: v.move_in_ready_specs,
							under_construction_contract: v.under_construction_contract,
						})
					})
				})
			})
			let f = {
				active: r.id,
				sales,
				salesInput,
				bustouts: cancels,
				closings: closings,
				starts: this.props.payload.starts.current,
				name: r.name,
				lastYearSales,
				lastYearCancels,
				projections,
				webAnalytics,
				trafficArray,
				specs,
				weeklyTotals: {
					gross: sales.length,
					busts: cancels.length,
					closings: closings.length,
					net: sales.length - cancels.length,
					traffic,
					builderTraffic,
					welcomeTraffic,
					copilot,
					starts: this.props.payload.starts.current.length,
					numberVisits,
				},
			}
			return f
		}
		const buildLife = () => {
			let weeklyTotals = {
				gross: 0,
				net: 0,
				busts: 0,
				traffic: 0,
				copilot: 0,
				closings: 0,
				starts: 0,
			}
			let allSales = []
			let closings = []
			let projections = []
			let bustouts = []
			let lastYearSales = []
			let lastYearCancels = []
			let traffic
			let starts
			// Viewing Year to date
			starts = _.filter(this.props.payload.exec.lots, (v) => {
				return v.start_date
			})
			weeklyTotals.starts = starts.length
			_.forEach(this.props.payload.sales.allSales, (v) => {
				if (v[sale_date]) {
					allSales.push(v)
					weeklyTotals.gross++
				}
				if (v[bustout_date]) {
					bustouts.push(v)
					weeklyTotals.busts++
				}
				if (v[closing_date]) {
					closings.push(v)
					weeklyTotals.closings++
				}
				// Last Year
				if (v[sale_date] && v[sale_date]) {
					lastYearSales.push(v)
				}
				if (v[bustout_date] && v[bustout_date]) {
					lastYearCancels.push(v)
				}
			})
			_.forEach(this.props.payload.exec.projections, (v) => {
				if (v.property == this.props.activeProperties[0]) {
					projections.push(v)
				}
			})
			weeklyTotals.net = weeklyTotals.gross - weeklyTotals.busts
			weeklyTotals.traffic =
				this.props.payload?.ltd?.traffic?.grouped + this.props.payload?.ltd?.traffic?.individual
			weeklyTotals.numberVisits = this.props.payload.exec.weeklyReport.trafficCount.ltd.numberVisits
			return {
				active: r.id,
				weeklyTotals,
				allSales,
				salesInput: allSales,
				sales: allSales,
				closings,
				projections,
				bustouts,
				lastYearSales,
				lastYearCancels,
				traffic,
				starts,
			}
		}
		if (r.id == "year") {
			d = buildYearly()
			d.dataBucket = "ytd"
		} else if (r.id == "ptd") {
			d = buildLife()
			d.dataBucket = "ptd"
		} else {
			d = buildWeekly()
			d.dataBucket = "week"
		}
		let weekData = buildWeekly()
		let ytdData = buildYearly()
		let lifeData = buildLife()
		let communityPerformance = this.props.payload.communityPerformance[this.props.payload.weekly.id]
		// First of month of the start date
		let firstOfMonth = moment.unix(this.state.times.startWeek).startOf("month").unix()
		let monthly = {}
		monthly.sales = _.filter(this.props.payload.sales.allSales, (v) => {
			return v[sale_date] >= firstOfMonth && v[sale_date] < this.state.times.endWeek
		})
		monthly.bustouts = _.filter(this.props.payload.bustouts.allBusts, (v) => {
			return v[bustout_date] >= firstOfMonth && v[bustout_date] < this.state.times.endWeek
		})
		monthly.closings = _.filter(this.props.payload.closings.allClosings, (v) => {
			return v[closing_date] >= firstOfMonth && v[closing_date] < this.state.times.endWeek
		})
		monthly.starts = _.filter(this.props.payload.starts.allStarts, (v) => {
			return v.start_date >= firstOfMonth && v.start_date < this.state.times.endWeek
		})
		this.setState(
			{
				...d,
				monthly,
				ptd: lifeData,
				property: prop,
				communityPerformance,
				...(settings.weekly && settings.weekly.summary
					? {
							summary: {
								weekly: weekData,
								ytd: ytdData,
							},
					  }
					: {}),
				weekly_message: prop ? prop.weekly_message : "",
			},
			() => {
				//console.log(this.state)
			}
		)
	}

	renderNav() {
		let f = _.map(this.state.nav, (r, i) => {
			var here = r.id == this.state.active ? true : false
			var classes = classNames("body__navItem", {
				here: here,
			})
			return (
				<li
					key={i}
					className={classes}
					onClick={() => {
						this.changeReport(r)
					}}>
					<div className="body__navTitle">
						<i className={r.icon} />
						<span>{r.name}</span>
					</div>
				</li>
			)
		})
		return f
		//return ret
	}

	generateText = () => {
		let obj = {
			title: "",
			date: "",
		}
		if (this.state.active == "week") {
			obj.title = `${this.props.payload.weekly.name} Weekly Report`
			obj.date = `Week ${this.state.times.curWeek} | Monday ${moment
				.unix(this.props.payload.time)
				.format("MMMM D")} - Sunday ${moment.unix(this.props.payload.time).add(6, "days").format("MMMM D")}`
			if (this.state.times.special) {
				obj.date = `Week ${this.state.times.curWeek} | ${moment
					.unix(this.state.times.startWeek)
					.format("dddd MMMM D")} - ${moment.unix(this.state.times.endWeek).format("dddd MMMM D")}`
			}
		} else if (this.state.active == "year") {
			//YTD
			// if this year, end time is now, if previous year, then should be end of week they're viewing.
			/* let end =
				this.state.times.reportYear == moment().year()
					? moment().format("MMMM D")
					: moment.unix(this.state.times.endWeek).format("MMMM D") */
			let end = moment.unix(this.state.times.endWeek).format("MMMM D")
			obj.title = `${this.props.payload.weekly.name} YTD Report`
			obj.date = `${moment().year(this.state.times.reportYear).startOf("year").format("MMMM D")} - ${end} ${
				this.state.times.endWeekYear
			}`
		} else if (this.state.active == "ptd") {
			obj.title = `${this.props.payload.weekly.name} Project To Date`
			obj.date = `Inception - ${moment.unix(this.state.times.endWeek).format("MMMM D")} ${
				this.state.times.endWeekYear
			}`
		}
		if (this.state.active == "summary") {
			obj.title = `${this.props.payload.weekly.name} Summary`
			obj.date = `Week ${this.state.times.curWeek} | Monday ${moment
				.unix(this.props.payload.time)
				.format("MMMM D")} - Sunday ${moment.unix(this.props.payload.time).add(6, "days").format("MMMM D")}`
			if (this.state.times.special) {
				obj.date = `Week ${this.state.times.curWeek} | ${moment
					.unix(this.state.times.startWeek)
					.format("dddd MMMM D")} - ${moment.unix(this.state.times.endWeek).format("dddd MMMM D")}`
			}
		}

		return obj
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (!this.props.payloadStatus) {
			return (
				<div>
					<Overlay />
					<LoadingOverlay />
				</div>
			)
		} else {
			return (
				<div className="globalCont c">
					<div className="top">
						<div className="top__logo">
							<Link to="/" className="w-full">
								<img src={settings.logo} alt="Pipsy" className="top__logoImg" />
							</Link>
						</div>
					</div>
					<div className="body">
						<div className="body__nav">
							<ul
								className={classNames("body__navList !block !min-h-0 lg:min-h-[100vh]", {
									active: this.state.navOpen,
								})}>
								{this.renderNav()}
							</ul>
						</div>
						<div className="body__stageCont">
							<WeeklyRender title={this.generateText()} {...this} type={"island"} />
						</div>
					</div>
					<Overlay />
					<LoadingOverlay />
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		loadingStatus: state.loadingStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getWeeklyPayload,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(WeeklyReport)
